import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private paymentapiUrl = `${environment.travel}/payment`;

  constructor(
    private _http: HttpClient
  ) { }

  createPayment(formData: any): Observable<any> {
    return this._http.post<any>(`${this.paymentapiUrl}/addpayment`, formData);
  }

  getAllPaymentsForInvoice(invoiceId: any, pageNo: any, pageSize: any, token: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 20
    }

    return this._http.post<any>(`${environment.travel}/payments/${invoiceId}`, paginationSettings)
  }

  getAllPaymentsOfLead(leadId: any, pageNo: any, pageSize: any, token: any): Observable<any> {
    const paginationSettings = {
      pageNumber: pageNo || 1,
      pageSize: pageSize || 20
    }

    return this._http.post<any>(`${environment.travel}/payments/${leadId}?type=lead`, paginationSettings)
  }

  getLatestPaymentOfLead(leadId:any): Observable<any>{
    return this._http.get(`${environment.travel}/payments/${leadId}`);
  }

  createPaymentAgainstLead(formData: any): Observable<any> {
    return this._http.post<any>(`${this.paymentapiUrl}/addpayment?type=lead`, formData);
  }

}
